export default __webpack_public_path__ + "static/media/htb-antonieta.59486214.jpg";